import { useParams, useNavigate } from '@tanstack/react-router';
import { Icon } from '../components/Icon.tsx';
import { PurchaseRequestPanel } from '../features/gsr/PurchaseRequestPanel.tsx';
import { t } from '../lib/strings.ts';

export function PurchaseRequestDetail(): JSX.Element {
  const { prId } = useParams({ from: '/purchase-requests/$prId' });
  const navigate = useNavigate();

  return (
    <div className="page space-y-6">
      <header className="flex items-center gap-4">
        <button
          onClick={() => void navigate({ to: '/gsr' })}
          className="btn-ghost btn-sm mt-0.5"
          aria-label={t.prDetail.ariaBack}
        >
          <Icon name="arrow_forward" size={15} />
        </button>
        <h1 className="text-2xl font-bold text-ink leading-tight">{t.prDetail.heading}</h1>
      </header>
      <PurchaseRequestPanel prId={prId} />
    </div>
  );
}
